import { Component } from '@angular/core';

@Component({
    selector: 'agentix-trial-signup-brand',
    templateUrl: './agentix-trial-signup-brand.component.html',
    styleUrls: ['./agentix-trial-signup-brand.component.scss'],
    standalone: false
})
export class AgentixTrialSignupBrandComponent {}
